import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b4b9052"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gridlistafacturas" }
const _hoisted_2 = { class: "table table-hover" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", null, "Cliente"),
    /*#__PURE__*/_createElementVNode("th", null, "Valor")
  ])
], -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { style: {"cursor":"pointer"} }
const _hoisted_6 = { class: "bold" }
const _hoisted_7 = { class: "bold" }
const _hoisted_8 = { class: "bold der blue" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "bold izq bold" }, "Total", -1))
const _hoisted_10 = { class: "bold der" }
const _hoisted_11 = { class: "bold der blue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.facturas, (factura, index) => {
        return (_openBlock(), _createElementBlock("tbody", {
          key: index,
          onClick: ($event: any) => (this.$router.push(`/facturas/${factura._id}`))
        }, [
          _createElementVNode("tr", _hoisted_5, [
            _createElementVNode("td", _hoisted_6, _toDisplayString($options.formatDate(factura.fechaFactura)), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(factura.descripcionCliente), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString($options.formatNumber(factura.totalGeneral)), 1)
          ])
        ], 8, _hoisted_4))
      }), 128)),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _hoisted_9,
          _createElementVNode("td", _hoisted_10, _toDisplayString($options.formatNumber2(this.totales.facturas)), 1),
          _createElementVNode("td", _hoisted_11, _toDisplayString($options.formatNumber(this.totales.total)), 1)
        ])
      ])
    ])
  ]))
}